import { z } from 'zod/v3';

import { sortingDirectionSchema } from 'features/procurement/schema';

const grirTabSchema = z.enum(['orders', 'invoices', 'credit-requests']);

const grirOrdersFiltersSchema = z.object({
  ordersStatuses: z.array(z.string()).optional(),
  ordersWarehouseCodes: z.array(z.string()).optional(),
  ordersVendorCodes: z.array(z.string()).optional(),
  ordersEarliestDeliveryDate: z.string().optional(),
  ordersLatestDeliveryDate: z.string().optional(),
});

const grirInvoicesFiltersSchema = z.object({
  invoicesStatuses: z.array(z.string()).optional(),
  invoicesTypes: z.array(z.string()).optional(),
});

const grirCreditRequestsFiltersSchema = z.object({
  creditRequestStatuses: z.array(z.string()).optional(),
  creditRequestEarliestRequestedDate: z.string().optional(),
  creditRequestLatestRequestedDate: z.string().optional(),
  creditRequestReasons: z.array(z.string()).optional(),
  creditRequestVendorCodes: z.array(z.string()).optional(),
});

const grirModalsSchema = z.object({
  invoiceIdForUpdate: z.string().optional(),
  vendorCodeForUpdate: z.string().optional(),
  venueIdForUpdate: z.string().optional(),
});

export const grirDetailSearchSchema = z.object({
  from: z.string().optional(),
  tab: grirTabSchema.default('orders'),
  ordersQ: z.string().optional(),
  ordersSortBy: z.string().optional(),
  ordersSortDirection: sortingDirectionSchema.optional(),
  ...grirOrdersFiltersSchema.shape,
  invoicesQ: z.string().optional(),
  invoicesSortBy: z.string().optional(),
  invoicesSortDirection: sortingDirectionSchema.optional(),
  ...grirInvoicesFiltersSchema.shape,
  creditRequestsQ: z.string().optional(),
  creditRequestsSortBy: z.string().optional(),
  creditRequestsSortDirection: sortingDirectionSchema.optional(),
  ...grirCreditRequestsFiltersSchema.shape,
  ...grirModalsSchema.shape,
});

export type GrirOrdersFilters = z.infer<typeof grirOrdersFiltersSchema>;
export type GrirInvoicesFilters = z.infer<typeof grirInvoicesFiltersSchema>;
export type GrirCreditRequestsFilters = z.infer<typeof grirCreditRequestsFiltersSchema>;
export type GrirModals = z.infer<typeof grirModalsSchema>;

export type GrirTab = z.infer<typeof grirTabSchema>;
